import { type GetHookResponse } from '../../hooks'
import { taskSnapshotEmployeesKey } from '../../keys'
import { useTantalimQuery } from '../../query'
import {
  DAY,
  HOUR,
  type SnapshotEmployeesInput,
  type SnapshotEmployeesSuccess,
  type UserSnapshotFull,
} from '@terros/common'

export function useSnapshotEmployees(input: SnapshotEmployeesInput): GetHookResponse<UserSnapshotFull[]> {
  return useTantalimQuery<SnapshotEmployeesInput, SnapshotEmployeesSuccess, UserSnapshotFull[]>({
    url: '/task/snapshot/employees',
    queryKey: taskSnapshotEmployeesKey(input),
    input,
    convertResponse: (data) => data.employees,
    options: {
      gcTime: DAY,
      staleTime: HOUR,
    },
  })
}
